import {
  base_contentActive,
  base_contentHover,
  table_tableRowSelectedHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.CreditCardDropdownOption {
    height: ${spacing(13)};
    display: flex;
    align-items: center;
    cursor: pointer;
    ${font_md};
    font-family: ${font_family_weight_regular};
    color: ${text_colorTextPrimary};

    &.small {
      padding: ${spacing(2)};
    }

    &.medium {
      padding: ${spacing(2)} ${spacing(5)};
    }

    .secondary {
      color: ${text_colorTextSecondary};
    }

    .selected-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${spacing(6)};
      height: ${spacing(6)};
      min-width: ${spacing(6)};
      min-height: ${spacing(6)};
      margin-right: ${spacing(4)};
    }

    .checkbox {
      margin-right: ${spacing(4)};
    }

    .option-label-wrapper {
      display: flex;
      flex-direction: column;
      gap: ${spacing(1)};
      overflow: hidden;
      margin-left: ${spacing(2)};
    }

    .option-sublabel {
      ${font_sm};
      color: ${text_colorTextSecondary};
    }

    .ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &:hover,
    &:focus,
    &[aria-selected='true'] {
      background-color: ${base_contentHover};
      outline: none;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: transparent;
      }
    }

    &.selected {
      background-color: ${base_contentActive};
      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: ${table_tableRowSelectedHover};
      }
    }
  }
`
